import React, { useEffect, useState } from 'react';
// import { Modal } from 'react-bootstrap';
// import { Link, useNavigate } from 'react-router-dom';
import Header from 'CoP/components/layouts/Header';
import Footer from 'CoP/components/layouts/Footer';
import Carousel from 'CoP/components/app/Carousel';
import CardCTA from 'CoP/components/app/CardCTA';
import ArticleCard from 'CoP/components/app/ArticleCard';
import Badge from 'CoP/components/app/Badge';
import YouTubePlayer from 'CoP/components/app/YouTubePlayer';
// import TalentaWindow from './TalentaWindow.jsx';
// import About from './About.jsx';
// import Contribution from './Contribution.jsx';
// import CardContainer from './CardContainer.jsx';

import Api from 'CoP/helpers/api';

import './style.css'

const COPHome = () => {
    const [errors, setErrors] = useState({})
    const [loading, setLoading] = useState({})
    const [copBanners, setCopBanners] = useState([])
    const [copCategories, setCopCategories] = useState([])
    const [selectedBadge, setSelectedBadge] = useState({id: '', name: 'Semua'}); // default badge
    const [copNews, setCopNews] = useState([])
    const [copYoutube, setCopYoutube] = useState([])

    const api = new Api();

    useEffect(() => {
        fetchCOPBHome()
        fetchCOPNews()
    }, [])

    const fetchCOPBHome = () => {
        setLoading({ ...loading, copBanners: true })

        api.getCOPHome()
            .then(response => {
                const bannerData = response.data.data.banners
                const categoryData = response.data.data.kategori_berita
                const youtubeData = response.data.data.youtube

                setCopBanners(bannerData)
                setCopCategories(categoryData)
                setCopYoutube(youtubeData)
            }).catch((error) => {
                const { data, status } = error.response
                setErrors(data.meta.error)
            }).finally(() => {
                setLoading({ ...loading, copBanners: false })
            })
    }

    const fetchCOPNews = (categoryId = null) => {
        setLoading({ ...loading, copNews: true })
        
        // Gunakan parameter categoryId jika ada, jika tidak gunakan selectedBadge.id
        const idToUse = categoryId !== null ? categoryId : (selectedBadge.id || '')
        
        api.getCOPNews(idToUse)
            .then(response => {
                const newsData = response.data?.data
                setCopNews(newsData)
            })
            .catch((error) => {
                const { data, status } = error.response
                setErrors(data.meta.error)
            })
            .finally(() => {
                setLoading({ ...loading, copNews: false })
            })
    }

    return (
        <div className='container-fluid p-0 overflow-hidden' style={{ backgroundColor: '#FAF9F5' }}>
            <Header />
            <div className='mb-lg-15 mb-md-5'>
                <div className='m-lg-5 m-md-0'>
                    <Carousel data={copBanners} />
                </div>
            </div>
            
            <div className='m-lg-15 m-5'>
                <div className='row d-flex align-items-center mb-5'>
                    <div className='col-md-1 border-end border-gray-300 mb-lg-0 mb-3'>
                        <div className='d-flex align-items-center justify-content-start' style={{ height: '100%' }}>
                            <i className="bi bi-grid-fill fs-1 text-primary"></i>
                            <p className='fs-7 fw-bold text-gray-800 ms-3'>Kategori CoP</p>
                        </div>
                    </div>
                    <div className='col-md-11 d-flex flex-wrap'>
                        <Badge 
                            label='Semua' 
                            variant={selectedBadge.name === 'Semua' ? 'primary' : 'light'} 
                            color={selectedBadge.name === 'Semua' ? 'white' : 'primary'} 
                            onClick={() => {
                                // Update state first
                                setSelectedBadge({id: '', name: 'Semua'});
                                // Then call API with the new ID directly
                                fetchCOPNews('');
                            }} 
                        />
                        {copCategories.map(item => (
                            <Badge 
                                key={item.id} 
                                label={item.nama_kategori} 
                                variant={selectedBadge.name === item.nama_kategori ? 'primary' : 'light'} 
                                color={selectedBadge.name === item.nama_kategori ? 'white' : 'primary'} 
                                onClick={() => {
                                    // Update state first
                                    setSelectedBadge({id: item.id, name: item.nama_kategori});
                                    // Then call API with the new ID directly
                                    fetchCOPNews(item.id);
                                }} 
                            />
                        ))}
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12 mb-8'>
                        <h3 className='fw-bold text-gray-800 fs-md-1 fs-4 text-start' style={{ textTransform: 'unset' }}>
                            Menjadi Sumber Pengetahuan Baru
                        </h3>
                        <p className='fs-5 text-gray-800 fs-md-5 fs-4 text-start'>
                            Mengetahui lebih dalam topik terbaru yang menginspirasi.
                        </p>
                    </div>
                    <div className='col-md-12'>
                        <div className='row'>
                            {copNews.map(item => (
                                <div className='col-md-4 mb-5'>
                                    <ArticleCard
                                        key={item.id}
                                        upload_thumbnail={item.upload_thumbnail}
                                        kategori={item.kategori.nama_kategori}
                                        judul={item.judul}
                                        abstrak={item.abstrak}
                                        id={item.id}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <CardCTA />
            </div>
            
            {copYoutube && copYoutube.length > 0 && (
                <div className='m-md-15 m-5'>
                    <div className='row'>
                        <div className='col-md-6'>
                            <YouTubePlayer key={copYoutube[0].id} videoId={copYoutube[0].link_youtube} />
                        </div>
                        <div className='col-md-6'>
                            <h3 className='fw-bold text-gray-800 mb-4 fs-md-1 fs-4 text-start' style={{ textTransform: 'unset' }}>{copYoutube[0].judul}</h3>
                            <div className='fs-5 text-gray-800 mb-4 fs-md-5 fs-4 text-start' style={{ textTransform: 'unset' }} dangerouslySetInnerHTML={{ __html: copYoutube[0].deskripsi }} />
                            {/* <div className='d-flex flex-column gap-3'>
                                <div className='d-flex align-items-center p-3 bg-light rounded-3'>
                                    <i className="bi bi-play-circle-fill fs-2 text-primary me-3"></i>
                                    <div>
                                        <h6 className='fw-bold mb-1'>Webinar Series: Digital Transformation</h6>
                                        <p className='text-muted mb-0 fs-7'>45 menit • 1.2K views</p>
                                    </div>
                                </div>
                                <div className='d-flex align-items-center p-3 bg-light rounded-3'>
                                    <i className="bi bi-play-circle-fill fs-2 text-primary me-3"></i>
                                    <div>
                                        <h6 className='fw-bold mb-1'>Tips Sukses Beasiswa LPDP</h6>
                                        <p className='text-muted mb-0 fs-7'>32 menit • 856 views</p>
                                    </div>
                                </div>
                                <div className='d-flex align-items-center p-3 bg-light rounded-3'>
                                    <i className="bi bi-play-circle-fill fs-2 text-primary me-3"></i>
                                    <div>
                                        <h6 className='fw-bold mb-1'>Community Building Workshop</h6>
                                        <p className='text-muted mb-0 fs-7'>28 menit • 634 views</p>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            )}
            <Footer />
        </div>
    )
}

export default COPHome